import { render, staticRenderFns } from "./selfListDetail.vue?vue&type=template&id=25e7ff4b&scoped=true&"
import script from "./selfListDetail.vue?vue&type=script&lang=js&"
export * from "./selfListDetail.vue?vue&type=script&lang=js&"
import style0 from "./selfListDetail.vue?vue&type=style&index=0&id=25e7ff4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7ff4b",
  null
  
)

export default component.exports